import { NgModule } from '@angular/core';
import { ReplaceLineBreaksPipe } from './nl2br-pipe';

@NgModule({
    imports: [
    ],
    declarations: [
        ReplaceLineBreaksPipe
    ],
    exports: [
        ReplaceLineBreaksPipe
    ]
})

export class ReplaceLineBreaksPipeModule { }
